import React, { useState, useRef, useEffect } from "react";

const OTPInput = ({ length = 4,getOtp=(otp)=>{},  }) => {
  const [otp, setOtp] = useState(Array(length).fill("")); 
  const inputRefs = useRef([]); 

  // Handle input change
  const handleChange = (index, value) => {
    if (isNaN(value)) return; 

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    getOtp(newOtp.join(""))

    if (value && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  // Handle backspace
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
  
      inputRefs.current[index - 1].focus();
    }
  };

  // Handle paste
  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();
    if (isNaN(pasteData)) return; 

    const pasteArray = pasteData.split("").slice(0, length); 
    const newOtp = [...otp];

    pasteArray.forEach((value, i) => {
      if (i < length) {
        newOtp[i] = value;
      }
    });

    setOtp(newOtp);


    const lastInputIndex = Math.min(pasteArray.length, length - 1);
    inputRefs.current[lastInputIndex].focus();
  };


  useEffect(() => {
    inputRefs.current[0].focus();
  }, []);

  return (
    <>
    
    <div style={{ display: "flex", gap: "10px" }}>
      {otp.map((digit, index) => (
        <input
          key={index}
          type="text"
          value={digit}
          maxLength={1}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          inputMode={"numeric"}
          ref={(el) => (inputRefs.current[index] = el)}
          style={{
            width: "50px",
            height: "50px",
            textAlign: "center",
            fontSize: "20px",
            border: "1px solid #ccc",
            background:"#e3eeff8f",
            borderRadius: "8px",
            outline: "none",
          }}
        />
      ))}
    </div>
    </>
  );
};

export default OTPInput;